var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetailArrow = function SvgDetailArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "detail-arrow_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "#1474FA",
    strokeWidth: 1.5,
    d: "M.75.75h14.5v14.5H.75z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#detail-arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1474FA",
    d: "M15.53 8.53a.75.75 0 0 0 0-1.06l-4.773-4.773a.75.75 0 0 0-1.06 1.06L13.939 8l-4.242 4.243a.75.75 0 0 0 1.06 1.06zM1 8v.75h14v-1.5H1z"
  }))));
};
export default SvgDetailArrow;